import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  classifierGeneralField,
  classifierGeneralItemField,
  classifierGeneralItemLangField,
} from '../../constants/classifier';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Table, Button, Popconfirm } from 'antd';
import { TableRowActions } from '../';
import classificatorTypes from '../../constants/classificators';
import { getConsumptionUsageColumns } from '../ClassifierHelper';

class ClassifierGeneralTable extends Component {
  static propTypes = {
    dataSource: PropTypes.object,
    t: PropTypes.func.isRequired,
    classifierId: PropTypes.string.isRequired,
    changeClassifier: PropTypes.func.isRequired,
    showModal: PropTypes.func.isRequired,
  };

  getAdditionalColumns = () => {
    const { t, classifierId } = this.props;

    if (classifierId === classificatorTypes.consumptionUsage) {
      return getConsumptionUsageColumns(t);
    }
    return [];
  };

  getColumns = () => {
    const { t, changeClassifier, classifierId, showModal } = this.props;

    return [
      {
        title: t('tableGeneral.code'),
        dataIndex: classifierGeneralItemField.CODE,
      },
      {
        title: t('tableGeneral.en'),
        dataIndex: [
          classifierGeneralItemField.LANG,
          classifierGeneralItemLangField.EN,
        ],
      },
      {
        title: t('tableGeneral.et'),
        dataIndex: [
          classifierGeneralItemField.LANG,
          classifierGeneralItemLangField.ET,
        ],
      },
      ...this.getAdditionalColumns(),
      {
        title: t('tableGeneral.actions'),
        render: (value) => (
          <TableRowActions>
            <Button
              shape="circle"
              icon={<EditOutlined />}
              size="small"
              type="primary"
              onClick={() => showModal(value[classifierGeneralItemField.CODE])}
            />
            <span className="ant-divider" />

            <Popconfirm
              title={t('popconfirm.title')}
              onConfirm={() =>
                changeClassifier(classifierId, {
                  [classifierGeneralItemField.CODE]:
                    value[classifierGeneralItemField.CODE],
                  [classifierGeneralItemField.ACTIVE]: false,
                })
              }
              okText={t('popconfirm.buttonYes')}
              cancelText={t('popconfirm.buttonNo')}
            >
              <Button
                shape="circle"
                icon={<DeleteOutlined />}
                size="small"
                type="primary"
              />
            </Popconfirm>
          </TableRowActions>
        ),
      },
    ];
  };

  render() {
    const { dataSource } = this.props;

    return (
      <React.Fragment>
        <h1>{dataSource[classifierGeneralField.TITLE]}</h1>
        <Table
          rowKey={classifierGeneralItemField.CODE}
          dataSource={dataSource[classifierGeneralField.ITEMS]}
          columns={this.getColumns()}
          pagination={false}
        />
      </React.Fragment>
    );
  }
}

export default ClassifierGeneralTable;
